import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_eyd2sh0t50: FaireBrandEntity = {
  token: "b_eyd2sh0t50",
  type: "brand",
  name: "LOHN (No duties | Ships from CAN/USA)",
  avatarUrl:
    "https://cdn.faire.com/fastly/b4a1796164b90ccb9354e37c133cbc2c19b500c0895f4c0226724bc1e966b04c.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/af19403bcf8a75e3e1b7a645fecc72a53840cc19a8552a3e9db21d9a5829d836.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/b4a1796164b90ccb9354e37c133cbc2c19b500c0895f4c0226724bc1e966b04c.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/af19403bcf8a75e3e1b7a645fecc72a53840cc19a8552a3e9db21d9a5829d836.jpeg",
  location: "Toronto, ON, CAN",
  minimumOrderDollars: 350,
  rating: 5,
  reviewCount: 30,
  isInsider: false,
  description:
    "To our US Customers ~ All US orders ship from Dallas, Texas. No duties or tariffs will be charged.\n\nNamed after the Estonian word for scent, LOHN creates unique, layered scents and colourful products that turn everyday moments into sensory journeys.\n\nWith a background in chemical engineering and a passion for scent and design, co-founders Victoria Mierzwa and Katerina Juskey launched LOHN in 2018.\n\nLOHN products are vegan, cruelty-free, paraben-free, phthalate-free and handmade in Canada.",
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:06:23.593Z",
    importedBy: "entity-db-cli",
  },
};
